// import React from 'react';

import { Link } from "react-router-dom";
import "../assets/css/style.css";
import "../assets/css/style.css.map";
import "../assets/css/slick.min.css";

import POTATOFLAKES from "../assests/img/ProductsImages/POTATOFLAKES.jpg";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import potatoban1 from "../assets/img/potatoban1.png";
import Footer from "./footer";

const Potatoflakes = () => {
  return (
    <div>
      <div classNameName="d-none d-md-block">
        <div
          id="slider"
          classNameName="ls-wp-container fitvidsignore hero-6 th-hero-carousel"
          style={{ margin: "0 auto" }}
        >
          <div
            classNameName="ls-slide"
            data-ls="duration:5000; kenburnsscale:1.2;"
          >
            <div className="infrastructure-name">
              <div style={{ marginTop: "-40px" }}>
                <ul style={{ listStyleType: "none", padding: 20 }}>
                  <li>
                    <h1
                      style={{ color: "white", margin: 0, fontFamily: "helvetica", padding: 0 }}
                       
                    >
                      POTATO FLAKES
                    </h1>
                  </li>
                  <li>
                    <Link to="/home" style={{ color: "white", padding: 4 }}>
                      <span
                        className="homeclass"
                        style={{ fontFamily: "helvetica" }}
                      >
                        Home
                      </span>{" "}
                      &nbsp;
                    </Link>
                    <span style={{ color: "white" }}>
                      &gt; &nbsp;
                      <span
                        className="redname"
                        style={{ fontFamily: "helvetica", color: "#F0B323" }}
                      >
                        Potato Flakes
                      </span>
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            <img
              width="2000"
              height=""
              src={potatoban1}
              className="ls-l ls-img-layer factory"
              alt="pic"
              decoding="async"
             
              data-ls="offsetxin:500; durationin:600; delayin:100; easingin:easeOutBack; rotatein:80; bgcolorin:transparent; colorin:transparent;"
            />
          </div>
        </div>
      </div>


      <h2 className="section-heading" style={{ fontFamily: "helvetica" }}>
        Potato Flakes
      </h2>
      <div
        className="about-sec overflow-hidden pb-5"
        style={{ backgroundColor: "#f8f9fa" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-xl-6 mt-4 mt-xl-0 d-flex justify-content-center align-items-center">
              <div
                className="testi-card-img"
                style={{
                  backgroundImage: `url(${POTATOFLAKES})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  width: "600px",
                  height: "500px",
                  boxShadow: "0 10px 20px rgba(0,0,0,0.2)",
                  borderRadius: "10px",
                  marginLeft: "-20px",
                }}
              ></div>
            </div>
            <div className="col-xl-6" style={{ marginTop: "66px" }}>
              <div className="title-area mb-30 text-center text-xl-start">
                <h4 className="sec-title" style={{ fontFamily: "helvetica" }}>
                  Benefits
                </h4>
              </div>
              <ul
                className="mt-n2 mb-25 text-center text-xl-start"
                style={{ fontFamily: "helvetica" }}
              >
                <li>Consistent quality and taste every time</li>
                <li>
                  No peeling, boiling, or mashing required—saves time and effort
                </li>
                <li>
                  Versatile ingredient for mashed potatoes, aloo bhujia,
                  samosas, parathas, chips, bakery items, and more
                </li>
                <li>
                  Acts as a great thickener for gravies and a crispy coating for
                  food items
                </li>
                <li>
                  Cost-effective—reduces fuel, electricity consumption, material
                  wastage, and processing time
                </li>
              </ul>
              <div className="title-area mb-30 text-center text-xl-start">
                <h4 className="sec-title" style={{ fontFamily: "helvetica" }}>
                  Preparation
                </h4>
              </div>
              <ul
                className="mt-n2 mb-25 text-center text-xl-start"
                style={{ fontFamily: "helvetica" }}
              >
                <li>Take one cup of potato flakes in a bowl.</li>
                <li>Add 3 to 4 cups of hot water and mix well.</li>
                <li>Your mashed potatoes are ready to use!</li>
              </ul>

              <div className="title-area mb-30 text-center text-xl-start">
                <h4 className="sec-title" style={{ fontFamily: "helvetica" }}>
                  Storage
                </h4>
              </div>
              <ul
                className="mt-n2 mb-25 text-center text-xl-start"
                style={{ fontFamily: "helvetica" }}
              >
                <li>
                  Store in a cool and dry place, away from direct sunlight and
                  strong odours.
                </li>
              </ul>
              <div className="title-area mb-30 text-center text-xl-start">
                <h4 className="sec-title" style={{ fontFamily: "helvetica" }}>
                  Ingredients
                </h4>
              </div>
              <ul
                className="mt-n2 mb-25 text-center text-xl-start"
                style={{ fontFamily: "helvetica" }}
              >
                <li>Dehydrated Potatoes</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Potatoflakes;
